import React from 'react';
import Input from '@kvika/input';
import { StyledLoginFormLabel, StyledLoginForm, StyledLoginHelperText } from '../styles/LoginStyles';
var LoginForm = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, error = _a.error, helperText = _a.helperText, onKeyPress = _a.onKeyPress, testId = _a.testId;
    return (React.createElement(StyledLoginForm, { "data-testid": "".concat(testId, "-loginForm") },
        label && React.createElement(StyledLoginFormLabel, { htmlFor: "phoneNumber" }, label),
        React.createElement(Input, { type: "tel", id: "phoneNumber", value: value, onChange: onChange, onBlur: onBlur, onKeyPress: onKeyPress, autoFocus: true, width: "MEDIUM", testId: "".concat(testId, "-input") }),
        error && helperText && React.createElement(StyledLoginHelperText, null, helperText)));
};
export default LoginForm;
//# sourceMappingURL=LoginForm.js.map